import { Checkbox, Input, Table, Dropdown, Divider } from "semantic-ui-react"
import { ReportType, SrcFieldValue } from "../../../../../constnats/reportConstants"
import { PERIODS, RESOURCE_SOURCE_TYPES, RESOURCE_SOURCE_TYPES_SHORT_FORMS } from "../../../../../constnats/resourceConstants"
import { RESOURCE_CATEGORIES } from "../../../../../constnats/resourceConstants"
import { SUPPORTED_YEARS } from "../../../../../constnats/generalConstants"
import Assert from "../../../../../utils/asserts"
import ObjCheck from "../../../../../utils/objCheck"
import { ResourceProps, sanitizeSuffix } from "../../../../../utils/reportResourceUtil"

function ResourceConfigTable({ rows }) {
    return <Table compact='very' >
        <Table.Header>
            <Table.Row>
                <Table.HeaderCell>Original Name</Table.HeaderCell>
                <Table.HeaderCell>Year</Table.HeaderCell>
                <Table.HeaderCell>Period</Table.HeaderCell>
                <Table.HeaderCell>Financial Document Type</Table.HeaderCell>
                <Table.HeaderCell>Source Type</Table.HeaderCell>
                <Table.HeaderCell>Format</Table.HeaderCell>
                <Table.HeaderCell>Note</Table.HeaderCell>
                <Table.HeaderCell>Suffix</Table.HeaderCell>
                <Table.HeaderCell>Original Only</Table.HeaderCell>
            </Table.Row>
        </Table.Header>
        <Table.Body>
            {rows}
        </Table.Body>
    </Table >
}



function ResourceConfigRow({ originalFileName, resourceProps, year, onYearChange,
    period, onPeriodChange, onResourcePropsChange, originalOnly,
    onOriginalOnlyChange }) {

    const resourcePropsCopy = Object.assign({}, resourceProps)

    function onResourcePropsChangeLocal(prop, val) {
        resourcePropsCopy[prop] = val
        onResourcePropsChange(resourcePropsCopy)
    }

    return <Table.Row>
        <Table.Cell collapsing>
            <p>{originalFileName}</p>
        </Table.Cell>
        <Table.Cell collapsing>
            <Dropdown
                onChange={(a, b) => onYearChange(b.value)}
                value={year}
                placeholder='Year'
                options={SUPPORTED_YEARS.map(c => {
                    return { key: c, text: c, value: c }
                })}
                fluid selection search />
        </Table.Cell>
        <Table.Cell collapsing>
            <Dropdown
                onChange={(a, b) => onPeriodChange(b.value)}
                value={period}
                placeholder='Period'
                options={PERIODS.map(c => {
                    return { key: c, text: c, value: c }
                })}
                fluid selection search />
        </Table.Cell>
        <Table.Cell collapsing>
            <Dropdown
                onChange={(c, v) => {
                    onResourcePropsChangeLocal("finDocType", v.value)
                    if(!ResourceProps.sourceTypeManuallyControlled(v.value)) {
                        Assert.trueVal(!!RESOURCE_SOURCE_TYPES_SHORT_FORMS[v.value]);
                        onResourcePropsChangeLocal("sourceType", RESOURCE_SOURCE_TYPES_SHORT_FORMS[v.value])
                    }
                }}
                value={resourcePropsCopy.finDocType}
                placeholder='Type'
                options={RESOURCE_CATEGORIES.map(c => {
                    return { key: c, text: c, value: c }
                })}
                fluid selection search />
        </Table.Cell>
        <Table.Cell collapsing>
            {ResourceProps.sourceTypeManuallyControlled(resourceProps.finDocType) ?
                <Dropdown
                    onChange={(c, v) =>
                        onResourcePropsChangeLocal("sourceType", v.value)}
                    value={resourcePropsCopy.sourceType}
                    placeholder='Source Type'
                    options={RESOURCE_SOURCE_TYPES.map(c => {
                        Assert.trueVal(!!RESOURCE_SOURCE_TYPES_SHORT_FORMS[c]);
                        return { key: c, text: c, value: RESOURCE_SOURCE_TYPES_SHORT_FORMS[c] }
                    })}
                    fluid selection search /> : <Divider/>
            }
        </Table.Cell>
        <Table.Cell collapsing>
            <Dropdown
                onChange={(c, v) =>
                    onResourcePropsChangeLocal("reportType", v.value)}
                value={resourcePropsCopy.reportType}
                placeholder='Type'
                options={ReportType.ALL.map(c => {
                    return { key: c, text: c, value: c }
                })}
                fluid selection search />
        </Table.Cell>
        <Table.Cell collapsing>
            <Checkbox checked={resourcePropsCopy.note == true}
                onChange={(evt, data) =>
                    onResourcePropsChangeLocal("note", data.checked)} />
        </Table.Cell>
        <Table.Cell collapsing>
            <Input placeholder='Suffix'
                value={resourcePropsCopy.suffix} onChange={v =>
                    onResourcePropsChangeLocal("suffix", sanitizeSuffix(v.target.value))
                } />
        </Table.Cell>
        <Table.Cell collapsing>
            <Checkbox checked={originalOnly}
                onChange={(evt, data) => onOriginalOnlyChange(data.checked)} />
        </Table.Cell>
    </Table.Row>

}


export { ResourceConfigTable, ResourceConfigRow }